export enum SignatureStatus {
  OPEN = 'OPEN',
  UNSIGNED = 'UNSIGNED',
  PARTIALLY_SIGNED = 'PARTIALLY_SIGNED',
  SIGNATURE_RULE_MISSING = 'MISSING_SIGN_OFF_REQUIREMENTS',
  FULLY_SIGNED = 'FULLY_SIGNED',
}
